import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, first, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { IAppConfig } from '@app/models/app-config.interface';
import { Endpoint } from '@app/constants/endpoints.constants';

import { environment } from '../../environments/environment';
import appInfo from '../../app-info';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private _appConfig: BehaviorSubject<IAppConfig> = new BehaviorSubject<IAppConfig>({
    production: environment.production,
    authUrl: environment.production
      ? 'https://sso.griddynamics.net'
      : 'https://sso-staging.cicd.tools.aws.griddynamics.net'
  });

  constructor(private http: HttpClient) {}

  public get config(): IAppConfig {
    return this._appConfig.getValue();
  }

  public get config$(): Observable<IAppConfig> {
    return this._appConfig.asObservable().pipe(filter((x) => !!x));
  }

  public loadConfig(): Observable<IAppConfig> {
    return this.http.get<IAppConfig>(`${Endpoint.Config}?key=${appInfo.buildHash}`).pipe(
      first(),
      tap((data: IAppConfig) => {
        this._appConfig.next(data);
      })
    );
  }
}
